// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"30001219","453":"5175509d","976":"02a38c52"}[chunkId] + ".chunk.js";
};